import service from "./service"

const resendInviteMail = async (data) => {
    return service(data)
}

export default resendInviteMail 